import { CurrencyPipe } from '@angular/common';
import { Component, OnInit, Pipe, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CcService } from '../../../../services/cc.service';
import { DataService } from '../../../../services/data.service';
import { PermissionsService } from 'src/services/PermissionsService';
import { RegistryService } from '../../../../services/registry.service';
import { ReportService } from '../../../../services/report.service';
import { RouterService } from '../../../../services/router.service';
import { SecurityService } from '../../../../services/security.service';
import { StockService } from '../../../../services/stock.service';
import { UserService } from '../../../../services/user.service';
import { Icc } from '../../../Interfaces/icc';
import { GetLicenses, ILicense } from '../../../Interfaces/icustomer';
import { statusString } from '../../../Interfaces/igeneralresponse';
import { IuserPermissionsResponse } from '../../../Interfaces/iuser';

@Component({
  selector: 'app-licenseslistall',
  templateUrl: './licenseslistall.component.html'
})

@Pipe({ name: 'safeHtml' })
export class LicensesListAllComponent implements OnInit {
  urlSafe: SafeResourceUrl;
  html: any;
  subRef$: Subscription;
  mensaje: string = "";
  formFilter: FormGroup;
  permissionsList = null;
  Permissions: IuserPermissionsResponse[] = [];
  MenuG: IuserPermissionsResponse[] = [];
  menuGList = new MatTableDataSource;
  progress: number;
  Columns: string[] = [];
  dataGrid: ILicense[] = [];
  dataList = null;
  _Regs: number = 0;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  ngAfterViewInit() {
    this.dataList.paginator = this.paginator;
  }

  constructor(
    public sanitizer: DomSanitizer,
    private ccservice: CcService,
    private formBuilder: FormBuilder,
    private securityService: SecurityService,
    private router: Router,
    private userservice: UserService,
    private routeparent: RouterService,
    private currencyPipe: CurrencyPipe,
    private _snackBar: MatSnackBar,
    private stockservice: StockService,
    private dataService: DataService,
    private reportService: ReportService,
    private permissionservice: PermissionsService,
    private registryService: RegistryService
  ) {
    this.formFilter = formBuilder.group({
      customerName: [''],
      providerName: [''],
      status: ["A", Validators.required],
      startDate: [new Date(), Validators.required],
      endDate: [new Date(), Validators.required],
      validator: ['x', Validators.required]
    });
    this.Columns = ['providerName', 'providerDocId', 'customerName', 'customerDocId', 'noveltyDate', 'license', 'idInstallation', 'statusName'] //, 'b_menu']
  }
  cc: Icc[];
  states: statusString[];

  ngOnInit() {
    this.permissionservice.getPermission("LICLIST").subscribe(result => {
      if (result.body.length == 0)
        this.mensaje = "No tiene permisos";
      else {
        for (const entry of result.body) {
          this.addPermission({ id: entry.id, function_code: entry.function_code, code: entry.code, description: entry.description, type: entry.type, icon: entry.icon, link: entry.link });
        }
        this.permissionsList = new MatTableDataSource<IuserPermissionsResponse>(this.Permissions);
        this.menuGList = new MatTableDataSource<IuserPermissionsResponse>(this.MenuG);
      }
    },
      (e) => {
        this.mensaje = e.error;
        console.log(e);
      });
    //status
    this.states = [];
    this.states.push({ name: "Activa", code: "A" });
    this.states.push({ name: "Inactiva", code: "I" });
    this.states.push({ name: "Suspendida", code: "S" });
    this.states.push({ name: "Solicitada", code: "R" });
  }

  addPermission(permission) {
    this.Permissions.push(permission);
    if (permission.type == "G") {
      this.MenuG.push(permission);
    }
    else {
    }
  }

  Filter() {
    this.dataGrid = [];
    this.formFilter.get('validator').setValue(null);
    this.mensaje = "Procesando";
    this._Regs = 0;
    this.paginator.pageIndex = 0;
    const _par: GetLicenses = {
      providerName: this.formFilter.value.providerName,
      customerName: this.formFilter.value.customerName,
      statusCode: this.formFilter.value.status,
      startDate: this.formFilter.value.startDate,
      endDate: this.formFilter.value.endDate
    };
    this.registryService.Licenses(_par).subscribe(result => {
      if (!result.body.isValid) {
        this.mensaje = result.body.error.description;
        this.formFilter.get('validator').setValue('xx');
      }
      else {
        for (const entry of result.body.resultData) {
          this.addData({
            id: entry.id, providerName: entry.providerName, providerDocId: entry.providerDocId, customerName: entry.customerName, customerDocId: entry.customerDocId,
            noveltyDate: entry.noveltyDate.toString().substring(0, 10), license: entry.license, idInstallation: entry.idInstallation,
            statusName: entry.statusName
          });
        }
        this.dataList = new MatTableDataSource<ILicense>(this.dataGrid);
        this._Regs = this.dataList.data.length;
        //if (this.appcustomerlistservice.currentPage > 0) {
        //  this.paginator.pageIndex = this.appcustomerlistservice.currentPage;
        //}
        this.dataList.paginator = this.paginator;
        this.mensaje = "";
        this.formFilter.get('validator').setValue('xx');

      }
    },
      (e) => {
        this.mensaje = e.error;
      });
  }

  addData(data) {
    this.dataGrid.push(data);
  }

  assembleHTMLItem(vp) {
    var strHTML = vp;
    return this.sanitizer.bypassSecurityTrustHtml(strHTML);
  }

  b_back() {
    //this.router.navigate([this.routeparent.routerParent]);
    var route = this.routeparent.getBackRoute();
    this.router.navigate([route], { skipLocationChange: true });

  }

  b_gen(link, id) {
    this.router.navigate([link]);
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }


}
